export const GET_TASKS_STATUS = 'GET_TASKS_STATUS';
export const GET_TIME_OFF_REQUESTS = 'GET_TIME_OFF_REQUESTS';
export const GET_EMPLOYEE_REVIEWS = 'GET_EMPLOYEE_REVIEWS';
export const GET_DRIVER_ACCESSORIALS = 'GET_DRIVER_ACCESSORIALS';
export const GET_TIME_SHEETS = 'GET_TIME_SHEETS';
export const GET_DRIVER_OF_THE_MONTH = 'GET_DRIVER_OF_THE_MONTH';
export const GET_DRIVER_SAFETY_BONUS = 'GET_DRIVER_SAFETY_BONUS';
export const GET_SUPERVISOR_BONUS = 'GET_SUPERVISOR_BONUS';
export const GET_EMPLOYEE_ACCESSORIALS = 'GET_EMPLOYEE_ACCESSORIALS';
